import { patientsApi } from '../patientApi';
import {
  ApiMessageResponse,
  GetDocumentTagsProps,
  GetPatientDocumentsQueryParamsProps,
  GetPatientDocumentsQueryResponseProps,
  UploadDocumentsParams,
  UploadDocumentsResponse
} from './documents.types';

export const documentsApi = patientsApi.injectEndpoints({
  endpoints: (builder) => ({
    deleteDocument: builder.mutation<
      ApiMessageResponse,
      { documentId: string; isBodyImage?: boolean; patientId: string }
    >({
      invalidatesTags: (_result, _error, arg) => [
        { id: arg.documentId, type: 'Documents' },
        { id: 'LIST', type: 'Documents' },
        ...(arg.isBodyImage ? [{ id: arg.patientId, type: 'Patient' }] : [])
      ],
      query: ({ documentId, patientId }) => ({
        method: 'DELETE',
        url: `/patients/${patientId}/documents/${documentId}`
      })
    }),
    downloadPatientDocument: builder.query<Blob, { documentId: string }>({
      query: ({ documentId }) => ({
        responseHandler: (response: Response) => {
          return response.blob().then((res) => res);
        },
        url: `/patient-documents/${documentId}/download`
      }),
      transformResponse: (response: Blob) => response
    }),
    getDocumentTags: builder.query<GetDocumentTagsProps, void>({
      query: () => `/document-tags`
    }),
    getPatientDocuments: builder.query<
      GetPatientDocumentsQueryResponseProps,
      GetPatientDocumentsQueryParamsProps
    >({
      providesTags: (result) =>
        result
          ? [
              ...result.data.map(({ _id }) => ({ id: _id, type: 'Documents' as const })),
              { id: 'LIST', type: 'Documents' }
            ]
          : [{ id: 'LIST', type: 'Documents' }],
      query: ({ limit = 20, pageNo = 0, patientId, source }) => ({
        params: {
          limit,
          pageNo,
          source
        },
        url: `/patients/${patientId}/documents`
      })
    }),
    updateDocument: builder.mutation({
      invalidatesTags: (_result, _error, arg) => [
        { id: arg.patientId, type: 'Patient' },
        { id: 'LIST', type: 'Documents' }
      ],
      query: ({ documentId, patientId, tags }) => ({
        body: {
          tags
        },
        method: 'PATCH',
        url: `/patients/${patientId}/documents/${documentId}`
      })
    }),
    uploadDocuments: builder.mutation<UploadDocumentsResponse, UploadDocumentsParams>({
      invalidatesTags: (_result, _error, arg) => [
        { id: 'LIST', type: 'Documents' },
        ...(arg.isBodyImage ? [{ id: arg.patientId, type: 'Patient' }] : [])
      ],
      query: ({ body, patientId }) => ({
        body,
        method: 'POST',
        url: `/patients/${patientId}/documents`
      })
    })
  })
});

export const {
  useDeleteDocumentMutation,
  useGetDocumentTagsQuery,
  useGetPatientDocumentsQuery,
  useLazyDownloadPatientDocumentQuery,
  useLazyGetPatientDocumentsQuery,
  useUpdateDocumentMutation,
  useUploadDocumentsMutation
} = documentsApi;
